import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  templateUrl: './park-led-time-view.html',
  selector: 'park-led-time-view'
})

export class ParkLedTimeViewComponent {
  @Input() public ledTime: any;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() getSearchStatus: boolean;

  public setEditMode() {
    this.getSearchStatusChange.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/settings/led-time/park-led-time-view.component.ts